import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faSync, faEye, faArrowUp, faArrowDown, faPlus } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './PedidosData.css'
import 'jspdf-autotable';
import baseURL from '../../url';
import { getProductMoneda } from '../../moneda';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import ProductMedia from '../../ProductMedia/ProductMedia';

const ORDER_STATUS_OPTIONS = ['Pendiente', 'Pagado', 'Enviado', 'Recibido', 'Entregado', 'Cancelado'];
const ORDER_STATUS_LABELS = {
    Pending: 'Pendiente',
    Pendiente: 'Pendiente',
    Paid: 'Pagado',
    Pagado: 'Pagado',
    Shipped: 'Enviado',
    Enviado: 'Enviado',
    Received: 'Recibido',
    Recibido: 'Recibido',
    Delivered: 'Entregado',
    Entregado: 'Entregado',
    Rejected: 'Cancelado',
    Rechazado: 'Cancelado',
    Cancelled: 'Cancelado',
    Canceled: 'Cancelado',
    Cancelado: 'Cancelado',
};

function getOrderStatusLabel(status) {
    return ORDER_STATUS_LABELS[status] || status;
}

function getOrderStatusColor(status) {
    switch (getOrderStatusLabel(status)) {
        case 'Pendiente':
            return '#DAA520';
        case 'Pagado':
            return '#008000';
        case 'Enviado':
            return '#780576';
        case 'Recibido':
            return '#7c3aed';
        case 'Entregado':
            return '#0f766e';
        case 'Cancelado':
            return '#dc2626';
        default:
            return '#111827';
    }
}

function parseOrderProducts(rawProducts) {
    try {
        const products = JSON.parse(rawProducts || '[]');
        return Array.isArray(products) ? products : [];
    } catch (error) {
        return [];
    }
}

function createEmptyOrderLine() {
    return {
        idProducto: '',
        item: '',
        cantidad: 1,
    };
}

function getProductVariants(producto) {
    if (!producto) {
        return [];
    }

    const variants = [];
    for (let index = 1; index <= 10; index += 1) {
        const variant = `${producto[`item${index}`] || ''}`.trim();
        if (variant !== '') {
            variants.push(variant);
        }
    }

    return variants;
}

export default function PedidosData() {
    const [pedidos, setPedidos] = useState([]);
    const [productos, setProductos] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [createModalVisible, setCreateModalVisible] = useState(false);
    const [nuevoEstado, setNuevoEstado] = useState('');
    const [nuevoTrackingNumber, setNuevoTrackingNumber] = useState('');
    const [nuevoTrackingUrl, setNuevoTrackingUrl] = useState('');
    const [pedido, setPedido] = useState({});
    const [selectedSection, setSelectedSection] = useState('texto');

    const [filtroId, setFiltroId] = useState('');
    const [filtroMesa, setFiltroMesa] = useState('');
    const [filtroEstado, setFiltroEstado] = useState('');
    const [filtroDesde, setFiltroDesde] = useState('');
    const [filtroHasta, setFiltroHasta] = useState('');
    const [ordenInvertido, setOrdenInvertido] = useState(false);
    const [numeroTelefono, setNumeroTelefono] = useState('');
    const [creandoPedido, setCreandoPedido] = useState(false);
    const [nuevoPedidoNombre, setNuevoPedidoNombre] = useState('');
    const [nuevoPedidoEmail, setNuevoPedidoEmail] = useState('');
    const [nuevoPedidoTelefono, setNuevoPedidoTelefono] = useState('');
    const [nuevoPedidoEntrega, setNuevoPedidoEntrega] = useState('');
    const [nuevoPedidoTipoEntrega, setNuevoPedidoTipoEntrega] = useState('envio');
    const [nuevoPedidoPago, setNuevoPedidoPago] = useState('transferencia bancaria');
    const [nuevoPedidoNota, setNuevoPedidoNota] = useState('');
    const [nuevoPedidoCodigo, setNuevoPedidoCodigo] = useState('');
    const [nuevoPedidoEstado, setNuevoPedidoEstado] = useState('Pendiente');
    const [nuevoPedidoTrackingNumber, setNuevoPedidoTrackingNumber] = useState('');
    const [nuevoPedidoTrackingUrl, setNuevoPedidoTrackingUrl] = useState('');
    const [nuevoPedidoClienteId, setNuevoPedidoClienteId] = useState('');
    const [nuevoPedidoLineas, setNuevoPedidoLineas] = useState([createEmptyOrderLine()]);
    useEffect(() => {
        cargarPedidos();
        cargarProductos();
        cargarUsuarios();
    }, []);


    const cargarPedidos = () => {
        fetch(`${baseURL}/pedidoGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setPedidos(Array.isArray(data.pedidos) ? [...data.pedidos].reverse() : []);
                console.log(data.pedidos)
            })
            .catch(error => console.error('Error al cargar pedidos:', error));
    };

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
            })
            .catch(error => console.error('Error al cargar productos para pedidos:', error));
    };

    const cargarUsuarios = () => {
        fetch(`${baseURL}/usuariosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    throw new Error(data.error);
                }

                if (Array.isArray(data.usuarios)) {
                    setUsuarios(data.usuarios);
                }
            })
            .catch(error => console.error('Error al cargar usuarios para pedidos:', error));
    };

    const eliminar = (idPedido) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#780576',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/pedidoDelete.php?idPedido=${idPedido}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );
                        cargarPedidos();
                    })
                    .catch(error => {
                        console.error('Error al eliminar :', error);
                        toast.error(error);
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setPedido(item);
        setNuevoEstado(getOrderStatusLabel(item.estado));
        setNuevoTrackingNumber(item.trackingNumber || '');
        setNuevoTrackingUrl(item.trackingUrl || '');
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const resetNuevoPedido = () => {
        setNuevoPedidoNombre('');
        setNuevoPedidoEmail('');
        setNuevoPedidoTelefono('');
        setNuevoPedidoEntrega('');
        setNuevoPedidoTipoEntrega('envio');
        setNuevoPedidoPago('transferencia bancaria');
        setNuevoPedidoNota('');
        setNuevoPedidoCodigo('');
        setNuevoPedidoEstado('Pendiente');
        setNuevoPedidoTrackingNumber('');
        setNuevoPedidoTrackingUrl('');
        setNuevoPedidoClienteId('');
        setNuevoPedidoLineas([createEmptyOrderLine()]);
    };

    const abrirCrearPedido = () => {
        resetNuevoPedido();
        setCreateModalVisible(true);
    };

    const cerrarCrearPedido = () => {
        setCreateModalVisible(false);
    };

    const handleUpdateText = (idPedido) => {
        const payload = {
            estado: nuevoEstado !== '' ? nuevoEstado : pedido.estado,
            trackingNumber: nuevoTrackingNumber,
            trackingUrl: nuevoTrackingUrl,
        };

        fetch(`${baseURL}/pedidoPut.php?idPedido=${idPedido}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    Swal.fire(
                        'Error!',
                        data.error,
                        'error'
                    );
                } else {
                    Swal.fire(
                        'Editado!',
                        data.mensaje,
                        'success'
                    );
                    cargarPedidos();
                    cerrarModal();
                }
            })
            .catch(error => {
                console.log(error.message);
                toast.error(error.message);
            });
    };



    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };

    const actualizarLineaPedido = (lineIndex, field, value) => {
        setNuevoPedidoLineas((prev) => prev.map((linea, index) => {
            if (index !== lineIndex) {
                return linea;
            }

            if (field === 'idProducto') {
                return {
                    idProducto: value,
                    item: '',
                    cantidad: 1,
                };
            }

            if (field === 'cantidad') {
                return {
                    ...linea,
                    cantidad: Math.max(1, Number(value) || 1),
                };
            }

            return {
                ...linea,
                [field]: value,
            };
        }));
    };

    const handleSeleccionarCliente = (userId) => {
        setNuevoPedidoClienteId(userId);

        if (!userId) {
            return;
        }

        const cliente = usuarios.find((item) => `${item.idUsuario}` === `${userId}`);
        if (!cliente) {
            return;
        }

        setNuevoPedidoNombre(cliente.nombre || '');
        setNuevoPedidoEmail(cliente.email || '');
        setNuevoPedidoTelefono(cliente.telefono || '');
        if (cliente.direccion) {
            setNuevoPedidoTipoEntrega('envio');
            setNuevoPedidoEntrega(cliente.direccion);
        }
    };

    const agregarLineaPedido = () => {
        setNuevoPedidoLineas((prev) => [...prev, createEmptyOrderLine()]);
    };

    const eliminarLineaPedido = (lineIndex) => {
        setNuevoPedidoLineas((prev) => {
            if (prev.length === 1) {
                return [createEmptyOrderLine()];
            }

            return prev.filter((_, index) => index !== lineIndex);
        });
    };

    const totalNuevoPedido = nuevoPedidoLineas.reduce((total, linea) => {
        const producto = productos.find((item) => `${item.idProducto}` === `${linea.idProducto}`);
        if (!producto) {
            return total;
        }

        return total + (Number(producto.precio || 0) * Math.max(1, Number(linea.cantidad) || 1));
    }, 0);

    const crearPedidoManual = async () => {
        if (creandoPedido) {
            return;
        }

        const lineasValidas = nuevoPedidoLineas.filter((linea) => `${linea.idProducto}` !== '');

        if (nuevoPedidoNombre.trim() === '' || nuevoPedidoEmail.trim() === '' || nuevoPedidoTelefono.trim() === '') {
            toast.error('Completa nombre, email y telefono.');
            return;
        }

        if (nuevoPedidoTipoEntrega === 'envio' && nuevoPedidoEntrega.trim() === '') {
            toast.error('Completa la direccion de envio.');
            return;
        }

        if (lineasValidas.length === 0) {
            toast.error('Agrega al menos un producto al pedido.');
            return;
        }

        for (const linea of lineasValidas) {
            const producto = productos.find((item) => `${item.idProducto}` === `${linea.idProducto}`);
            const variants = getProductVariants(producto);

            if (!producto) {
                toast.error('Uno de los productos seleccionados ya no existe.');
                return;
            }

            if (variants.length > 0 && `${linea.item || ''}`.trim() === '') {
                toast.error(`Selecciona una variante para ${producto.titulo}.`);
                return;
            }
        }

        setCreandoPedido(true);

        try {
            const response = await fetch(`${baseURL}/pedidoAdminPost.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    idUsuario: nuevoPedidoClienteId ? Number(nuevoPedidoClienteId) : null,
                    nombre: nuevoPedidoNombre,
                    email: nuevoPedidoEmail,
                    telefono: nuevoPedidoTelefono,
                    entrega: nuevoPedidoTipoEntrega === 'pickup' ? 'Retiro en persona' : nuevoPedidoEntrega,
                    pago: nuevoPedidoPago,
                    nota: nuevoPedidoNota,
                    codigo: nuevoPedidoCodigo,
                    estado: nuevoPedidoEstado,
                    trackingNumber: nuevoPedidoTrackingNumber,
                    trackingUrl: nuevoPedidoTrackingUrl,
                    items: lineasValidas.map((linea) => ({
                        idProducto: Number(linea.idProducto),
                        item: linea.item,
                        cantidad: Math.max(1, Number(linea.cantidad) || 1),
                    })),
                }),
            });

            const data = await response.json();

            if (data.error) {
                toast.error(data.error);
                return;
            }

            Swal.fire('Pedido creado', data.mensaje, 'success');
            cerrarCrearPedido();
            cargarPedidos();
        } catch (error) {
            console.error('Error al crear pedido manual:', error);
            toast.error('No se pudo crear el pedido.');
        } finally {
            setCreandoPedido(false);
        }
    };

    const filtrados = pedidos.filter(item => {
        const idMatch = item.idPedido.toString().includes(filtroId);
        const estadoMatch = !filtroEstado || getOrderStatusLabel(item.estado) === filtroEstado;
        const desdeMatch = !filtroDesde || new Date(item.createdAt) >= new Date(filtroDesde);

        // Incrementamos la fecha "hasta" en un día para que incluya la fecha seleccionada
        const adjustedHasta = new Date(filtroHasta);
        adjustedHasta.setDate(adjustedHasta.getDate() + 1);

        const hastaMatch = !filtroHasta || new Date(item.createdAt) < adjustedHasta;
        return idMatch && estadoMatch && desdeMatch && hastaMatch;
    });


    const recargarProductos = () => {
        cargarPedidos();
    };
    const invertirOrden = () => {
        setPedidos([...pedidos].reverse());
        setOrdenInvertido(!ordenInvertido);
    };
    const descargarExcel = () => {
        let totalGeneral = 0;

        const data = filtrados.map(item => {
            const total = parseFloat(item.total); // Convertir a número
            totalGeneral += total;
            const productos = parseOrderProducts(item.productos);
            const infoProductos = productos.map(producto => `${producto.titulo} - ${getProductMoneda(producto)}${producto.precio} - x${producto.cantidad}  `);
            return {
                'ID Pedido': item.idPedido,
                'Estado': getOrderStatusLabel(item.estado),
                'Nombre': item.nombre,
                'Email': item.email,
                'Telefono': item.telefono,
                'Pago': item.pago,
                'Entrega': item.entrega,
                'Nota': item.nota,
                'Productos': infoProductos.join('\n'),
                'Codigo': item.codigo,
                'Total': `${getProductMoneda()} ${total.toFixed(2)}`,
                'Fecha': item.createdAt,
            };
        });

        // Formatear el total general
        const formattedTotal = `${getProductMoneda()} ${totalGeneral.toFixed(2)}`;

        // Agregar fila con el total general
        const totalRow = {

            'ID Pedido': '',
            'Estado': '',
            'Nombre': '',
            'Email': '',
            'Telfono': '',
            'Pago': '',
            'Entrega': '',
            'Nota': '',
            'Productos': '',
            'Codigo': 'Total General:',
            'Total': formattedTotal,
            'Fecha': '',
        };

        data.push(totalRow);

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'pedidos');
        XLSX.writeFile(wb, 'pedidos.xlsx');
    };


    const descargarPDF = () => {
        const pdf = new jsPDF('landscape'); // Orientación horizontal
        pdf.text('Lista de Pedidos', 10, 10);

        const columns = [
            { title: 'ID Pedido', dataKey: 'idPedido' },
            { title: 'Estado', dataKey: 'estado' },
            { title: 'Nombre', dataKey: 'nombre' },
            { title: 'Email', dataKey: 'email' },
            { title: 'Telfono', dataKey: 'telefono' },
            { title: 'Pago', dataKey: 'pago' },
            { title: 'Entrega', dataKey: 'entrega' },
            { title: 'Nota', dataKey: 'nota' },
            { title: 'Productos', dataKey: 'productos' },
            { title: 'Codigo', dataKey: 'codigo' },
            { title: 'Total', dataKey: 'total' },
            { title: 'Fecha', dataKey: 'createdAt' },
        ];

        let totalGeneral = 0;

        const data = filtrados.map(item => {
            const total = parseFloat(item.total); // Convertir a número
            totalGeneral += total;
            const productos = parseOrderProducts(item.productos);
            const infoProductos = productos.map(producto => `${producto.titulo} - ${getProductMoneda(producto)}${producto.precio} - x${producto.cantidad}  `);
            return {
                idPedido: item.idPedido,
                estado: getOrderStatusLabel(item.estado),
                nombre: item.nombre,
                email: item.email,
                telefono: item.telefono,
                pago: item.pago,
                entrega: item.entrega,
                nota: item.nota,
                productos: infoProductos.join('\n'),
                codigo: item.codigo,
                total: `${getProductMoneda()} ${total.toFixed(2)}`,
                createdAt: item.createdAt,
            };
        });

        // Formatear el total general
        const formattedTotal = `${getProductMoneda()} ${totalGeneral.toFixed(2)}`;

        // Agregar fila con el total general
        const totalRow = {
            idPedido: '',
            estado: '',
            nombre: '',
            email: '',
            telefono: '',
            pago: '',
            entrega: '',
            nota: '',
            productos: '',
            codigo: 'Total General:',
            total: formattedTotal,
            createdAt: '',
        };

        data.push(totalRow);

        pdf.autoTable({
            head: [columns.map(col => col.title)],
            body: data.map(item => Object.values(item)),
        });

        pdf.save('pedidos.pdf');
    };
    const handleDownloadPDF = () => {
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        let y = 10;

        // Agregar título
        pdf.setFontSize(10);


        // Obtener los detalles del pedido actualmente mostrado en el modal
        const pedidoActual = pedido;


        // Agregar detalles del pedido al PDF
        const pedidoData = [
            [`ID Pedido:`, `${pedidoActual.idPedido}`],
            [`Estado:`, `${getOrderStatusLabel(pedidoActual.estado)}`],
            [`Nombre:`, `${pedidoActual.nombre}`],
            [`Email:`, `${pedidoActual.email}`],
            [`Telefono:`, `${pedidoActual.telefono}`],
            [`Pago:`, `${pedidoActual.pago}`],
            [`Entrega:`, `${pedidoActual.entrega}`],
            [`Nota:`, `${pedidoActual.nota}`],
            [`Código:`, `${pedidoActual.codigo}`],
            [`Total:`, `${getProductMoneda()} ${pedidoActual.total}`],
            [`Fecha:`, `${pedidoActual.createdAt}`]
        ];
        pdf.autoTable({
            startY: y,
            head: [['Detalle del pedido', 'Valor']],
            body: pedidoData,
        });
        y = pdf.autoTableEndPosY() + 5;

        y += 5;

        // Obtener los productos del pedido actual
        const productosPedido = parseOrderProducts(pedidoActual.productos);

        // Generar sección de productos con imágenes y contenido
        for (let i = 0; i < productosPedido.length; i++) {
            if (y + 30 > pdf.internal.pageSize.getHeight()) {
                pdf.addPage();
                y = 10;
            }

            const producto = productosPedido[i];

            pdf.setFontSize(8);

            // Muestra la imagen a la izquierda de los datos del producto
            if (producto.imagen) {
                pdf.addImage(producto.imagen, 'JPEG', 15, y, 20, 20); // Ajusta el tamaño de la imagen aquí
            } else {
                // Si no hay URL de imagen, simplemente dejar un espacio en blanco
                pdf.text("Imagen no disponible", 5, y + 15);
            }

            if (producto) {
                pdf.text(`Producto: ${producto.titulo}`, 39, y + 3);
                pdf.text(`Precio: ${getProductMoneda(producto)} ${producto.precio}`, 39, y + 11);
                pdf.text(`Cantidad: ${producto.cantidad}`, 39, y + 15);
                pdf.text(`${producto.item}`, 39, y + 19);
            }

            y += 25; // Incrementar y para la siguiente posición
        }

        // Guardar el PDF
        pdf.save('pedido.pdf');
    };


    return (
        <div>
            <div className='deFlexContent'>

                <div className='deFlex2'>
                    <button className='btnSave' onClick={abrirCrearPedido}><FontAwesomeIcon icon={faPlus} /> Crear pedido</button>
                    <button className='excel' onClick={descargarExcel}><FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                    <button className='pdf' onClick={descargarPDF}><FontAwesomeIcon icon={faArrowDown} /> PDF</button>
                </div>
                <div className='filtrosContain'>
                    <div className='inputsColumn'>
                        <input type="date" value={filtroDesde} onChange={(e) => setFiltroDesde(e.target.value)} placeholder='Desde' />
                    </div>
                    <div className='inputsColumn'>
                        <input type="date" value={filtroHasta} onChange={(e) => setFiltroHasta(e.target.value)} placeholder='Hasta' />
                    </div>

                    <div className='inputsColumn'>
                        <input type="number" value={filtroId} onChange={(e) => setFiltroId(e.target.value)} placeholder='Id Pedido' />
                    </div>

                    <div className='inputsColumn'>
                        <select value={filtroEstado} onChange={(e) => setFiltroEstado(e.target.value)}>
                            <option value="">Estado</option>
                            {ORDER_STATUS_OPTIONS.map((status) => (
                                <option key={status} value={status}>{status}</option>
                            ))}
                        </select>
                    </div>
                    <button className='reload' onClick={recargarProductos}><FontAwesomeIcon icon={faSync} /></button>
                    <button className='reverse' onClick={invertirOrden}>
                        {ordenInvertido ? <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faArrowDown} />}
                    </button>

                </div>

            </div>

            {createModalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Crear pedido</button>
                            <span className="close" onClick={cerrarCrearPedido}>
                                &times;
                            </span>
                        </div>

                        <div className='sectiontext'>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Cliente</legend>
                                    <select value={nuevoPedidoClienteId} onChange={(e) => handleSeleccionarCliente(e.target.value)}>
                                        <option value=''>Seleccionar cliente guardado</option>
                                        {usuarios
                                            .filter((usuario) => usuario.rol !== 'admin')
                                            .map((usuario) => (
                                                <option key={usuario.idUsuario} value={usuario.idUsuario}>
                                                    {usuario.nombre} - {usuario.email}
                                                </option>
                                            ))}
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Nombre</legend>
                                    <input value={nuevoPedidoNombre} onChange={(e) => setNuevoPedidoNombre(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>Email</legend>
                                    <input type='email' value={nuevoPedidoEmail} onChange={(e) => setNuevoPedidoEmail(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>Telefono</legend>
                                    <input value={nuevoPedidoTelefono} onChange={(e) => setNuevoPedidoTelefono(e.target.value)} />
                                </fieldset>
                                <fieldset>
                                    <legend>Tipo de entrega</legend>
                                    <select value={nuevoPedidoTipoEntrega} onChange={(e) => setNuevoPedidoTipoEntrega(e.target.value)}>
                                        <option value='pickup'>Retiro en persona</option>
                                        <option value='envio'>Envio</option>
                                    </select>
                                </fieldset>
                                {nuevoPedidoTipoEntrega === 'envio' && (
                                    <fieldset>
                                        <legend>Direccion de envio</legend>
                                        <input value={nuevoPedidoEntrega} onChange={(e) => setNuevoPedidoEntrega(e.target.value)} placeholder='Ingresa la direccion' />
                                    </fieldset>
                                )}
                                <fieldset>
                                    <legend>Numero de envio</legend>
                                    <input value={nuevoPedidoTrackingNumber} onChange={(e) => setNuevoPedidoTrackingNumber(e.target.value)} placeholder='Opcional' />
                                </fieldset>
                                <fieldset>
                                    <legend>Link de seguimiento</legend>
                                    <input value={nuevoPedidoTrackingUrl} onChange={(e) => setNuevoPedidoTrackingUrl(e.target.value)} placeholder='https://...' />
                                </fieldset>
                                <fieldset>
                                    <legend>Pago</legend>
                                    <select value={nuevoPedidoPago} onChange={(e) => setNuevoPedidoPago(e.target.value)}>
                                        <option value='transferencia bancaria'>Transferencia bancaria</option>
                                        <option value='efectivo'>Efectivo</option>
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Estado inicial</legend>
                                    <select value={nuevoPedidoEstado} onChange={(e) => setNuevoPedidoEstado(e.target.value)}>
                                        {ORDER_STATUS_OPTIONS.map((status) => (
                                            <option key={status} value={status}>{status}</option>
                                        ))}
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Codigo</legend>
                                    <input value={nuevoPedidoCodigo} onChange={(e) => setNuevoPedidoCodigo(e.target.value)} />
                                </fieldset>
                                <fieldset className='pedidoFieldsetWide'>
                                    <legend>Nota</legend>
                                    <input value={nuevoPedidoNota} onChange={(e) => setNuevoPedidoNota(e.target.value)} />
                                </fieldset>
                            </div>

                            <div className='pedidoCreateLines'>
                                <div className='pedidoCreateLinesHeader'>
                                    <h3>Productos del pedido</h3>
                                    <button type='button' className='btnSave' onClick={agregarLineaPedido}>
                                        <FontAwesomeIcon icon={faPlus} /> Agregar producto
                                    </button>
                                </div>

                                {nuevoPedidoLineas.map((linea, index) => {
                                    const productoSeleccionado = productos.find((item) => `${item.idProducto}` === `${linea.idProducto}`);
                                    const variants = getProductVariants(productoSeleccionado);

                                    return (
                                        <div className='pedidoCreateLine' key={`linea-${index}`}>
                                            <div className='pedidoCreateLineGrid'>
                                                <fieldset>
                                                    <legend>Producto</legend>
                                                    <select value={linea.idProducto} onChange={(e) => actualizarLineaPedido(index, 'idProducto', e.target.value)}>
                                                        <option value=''>Selecciona un producto</option>
                                                        {productos.map((producto) => (
                                                            <option key={producto.idProducto} value={producto.idProducto}>
                                                                {producto.titulo}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </fieldset>

                                                <fieldset>
                                                    <legend>Variante</legend>
                                                    <select
                                                        value={linea.item}
                                                        onChange={(e) => actualizarLineaPedido(index, 'item', e.target.value)}
                                                        disabled={variants.length === 0}
                                                    >
                                                        <option value=''>{variants.length === 0 ? 'Sin variantes' : 'Selecciona una variante'}</option>
                                                        {variants.map((variant) => (
                                                            <option key={variant} value={variant}>{variant}</option>
                                                        ))}
                                                    </select>
                                                </fieldset>

                                                <fieldset>
                                                    <legend>Cantidad</legend>
                                                    <input
                                                        type='number'
                                                        min='1'
                                                        value={linea.cantidad}
                                                        onChange={(e) => actualizarLineaPedido(index, 'cantidad', e.target.value)}
                                                    />
                                                </fieldset>
                                            </div>

                                            <div className='pedidoCreateLineActions'>
                                                <span className='pedidoCreateLinePrice'>
                                                    {productoSeleccionado ? `${getProductMoneda(productoSeleccionado)} ${(Number(productoSeleccionado.precio || 0) * Math.max(1, Number(linea.cantidad) || 1)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}` : `${getProductMoneda()} 0`}
                                                </span>
                                                <button type='button' className='eliminar' onClick={() => eliminarLineaPedido(index)}>
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className='pedidoCreateFooter'>
                                <strong>Total estimado: {getProductMoneda()} {`${totalNuevoPedido}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</strong>
                                <button className='btnPost' onClick={crearPedidoManual} disabled={creandoPedido}>
                                    {creandoPedido ? 'Creando...' : 'Crear pedido'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Id Pedido</th>
                            <th>Estado</th>
                            <th>Nombre</th>
                            <th>Email</th>
                            <th>Telefono</th>
                            <th>Entrega</th>
                            <th>Pago</th>
                            <th>Total</th>
                            <th>Fecha</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filtrados.map(item => (
                            <tr key={item.idPedido}>
                                <td>{item.idPedido}</td>

                                <td style={{ color: getOrderStatusColor(item?.estado) }}>
                                    {getOrderStatusLabel(item?.estado)}
                                </td>
                                <td>{item.nombre}</td>
                                <td>{item.email}</td>
                                <td>{item.telefono}</td>
                                <td>{item.entrega}</td>
                                <td>{item.pago}</td>
                                <td style={{ color: '#008000', }}>{getProductMoneda()} {item.total}</td>
                                <td>{item.createdAt}</td>
                                <td>

                                    <button className='eliminar' onClick={() => eliminar(item.idPedido)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                    <button className='editar' onClick={() => abrirModal(item)}>

                                        <FontAwesomeIcon icon={faEye} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>
            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Pedido
                                </button>
                                <button onClick={handleDownloadPDF} className='texto'>Descargar PDF</button>
                            </div>

                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>ID Pedido</legend>
                                    <input
                                        value={pedido.idPedido}
                                        disabled

                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Nombre</legend>
                                    <input
                                        value={pedido.nombre}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Email</legend>
                                    <input
                                        value={pedido.email}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Telefono</legend>
                                    <input
                                        value={pedido.telefono}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Pago</legend>
                                    <input
                                        value={pedido.pago}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Entrega</legend>
                                    <input
                                        value={pedido.entrega}
                                        disabled

                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Codigo</legend>
                                    <input
                                        value={pedido.codigo}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Nota</legend>
                                    <input
                                        value={pedido.nota}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Fecha </legend>
                                    <input
                                        value={pedido.createdAt}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Total </legend>
                                    <input
                                        value={pedido.total}
                                        disabled

                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Numero de envio</legend>
                                    <input
                                        value={nuevoTrackingNumber}
                                        onChange={(e) => setNuevoTrackingNumber(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Link de seguimiento</legend>
                                    <input
                                        value={nuevoTrackingUrl}
                                        onChange={(e) => setNuevoTrackingUrl(e.target.value)}
                                        placeholder='https://...'
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Estado</legend>
                                    <select
                                        value={nuevoEstado !== '' ? nuevoEstado : pedido.estado}
                                        onChange={(e) => setNuevoEstado(e.target.value)}
                                    >
                                        {ORDER_STATUS_OPTIONS.map((status) => (
                                            <option key={status} value={status}>{status}</option>
                                        ))}
                                    </select>
                                </fieldset>

                            </div>
                            <div className='cardsProductData'>
                                {parseOrderProducts(pedido.productos).map((producto, index) => (
                                    <div key={`${producto.titulo || 'producto'}-${index}`} className='cardProductData'>
                                        <ProductMedia src={producto.imagen} alt={producto.titulo} className="productMediaThumb" />
                                        <div className='cardProductDataText'>
                                            <h3>{producto.titulo}</h3>
                                            <strong>{getProductMoneda(producto)} {producto.precio} <span>x{producto.cantidad}</span></strong>
                                            <span>{producto.item}</span>

                                        </div>
                                    </div>
                                ))}
                            </div>

                            <button className='btnPost' onClick={() => handleUpdateText(pedido.idPedido)} >Guardar </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
